import axios from "axios";
export default {
  getThumbnail(url, cb){
    axios.get(`https://vimeo.com/api/oembed.json?url=${url}`).then((response) => {
      cb(response.data)
    })
  }
}